const ListingActivationConstants = {
  ERROR_CODE: {
    INVALID_FIELDS: 'listingActivationInvalidFields',
    LISTING_BLOCKED: 'listingBlocked',
    CONTACT_BLOCKED: 'contactBlocked',
    DIGITALLY_ALTERED_PHOTOS_ATTESTATION_REQUIRED: 'digitallyAlteredPhotosAttestationRequired',
  },
};

export default ListingActivationConstants;
